'use strict';
import $ from 'jquery';

export default class LangDropdown {
    static init() {
        $('.lang-dropdown').each((index, el) => {
            new LangDropdown($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.el.on('click', this.onClick.bind(this));
        $(window).on('click', this.onWindowClick.bind(this));
    }

    onWindowClick(e) {
        if (!$(e.originalEvent.target).hasClass('lang-dropdown')) {
            this.onBlur(e);
        }
    }

    onClick(e) {
        e.preventDefault();
        if ($('.lang-dropdown-ul').is(':visible')) {
            $('.lang-dropdown-ul').hide();
            this.el.show();
        } else {
            $('.lang-dropdown-ul').show();
            this.el.hide();
        }
    }

    onHover(e) {
        e.preventDefault();
        this.el.hide();
        $('.lang-dropdown-ul').show();
    }

    onBlur(e) {
        $('.lang-dropdown-ul').hide();
        this.el.show();
    }
}